import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";

import App from "./App";

const AllPlants = lazy(() => import("./components/AllPlants"));

function Main() {
    return (
        <BrowserRouter>
            <Suspense fallback={<h2>Loading...</h2>}>
                <Routes>
                    <Route path="/" element={<App />} />
                    <Route path="/plants" element={<AllPlants />} />
                </Routes>
            </Suspense>
        </BrowserRouter>
    );
}

export default Main;